export default __webpack_public_path__ + "static/media/Pretendard-Thin.subset.770619bf.woff2";